import { IPaisesResponse } from "../../interfaces/dados-pessoais/paises-cw3-response.interface";

export const PAISES: IPaisesResponse = {
    data: [
        {
            "siglaPaisDoisCaracteres": "AD",
            "siglaPaisTresCaracteres": "AND",
            "nomePais": "Andorra",
            "codigoDdi": "376"
        },
        {
            "siglaPaisDoisCaracteres": "AE",
            "siglaPaisTresCaracteres": "ARE",
            "nomePais": "Emirados Árabes Unidos",
            "codigoDdi": "971"
        },
        {
            "siglaPaisDoisCaracteres": "AF",
            "siglaPaisTresCaracteres": "AFG",
            "nomePais": "Afeganistão",
            "codigoDdi": "93"
        },
        {
            "siglaPaisDoisCaracteres": "AG",
            "siglaPaisTresCaracteres": "ATG",
            "nomePais": "Antígua e Barbuda",
            "codigoDdi": "1-268"
        },
        {
            "siglaPaisDoisCaracteres": "AI",
            "siglaPaisTresCaracteres": "AIA",
            "nomePais": "Anguilla",
            "codigoDdi": "1-264"
        },
        {
            "siglaPaisDoisCaracteres": "AL",
            "siglaPaisTresCaracteres": "ALB",
            "nomePais": "Albânia",
            "codigoDdi": "355"
        },
        {
            "siglaPaisDoisCaracteres": "AM",
            "siglaPaisTresCaracteres": "ARM",
            "nomePais": "Armênia",
            "codigoDdi": "374"
        },
        {
            "siglaPaisDoisCaracteres": "AO",
            "siglaPaisTresCaracteres": "AGO",
            "nomePais": "Angola",
            "codigoDdi": "244"
        },
        {
            "siglaPaisDoisCaracteres": "AR",
            "siglaPaisTresCaracteres": "ARG",
            "nomePais": "Argentina",
            "codigoDdi": "54"
        },
        {
            "siglaPaisDoisCaracteres": "AS",
            "siglaPaisTresCaracteres": "ASM",
            "nomePais": "Samoa Americana",
            "codigoDdi": "1-684"
        },
        {
            "siglaPaisDoisCaracteres": "AT",
            "siglaPaisTresCaracteres": "AUT",
            "nomePais": "Austria",
            "codigoDdi": "43"
        },
        {
            "siglaPaisDoisCaracteres": "AU",
            "siglaPaisTresCaracteres": "AUS",
            "nomePais": "Austrália",
            "codigoDdi": "61"
        },
        {
            "siglaPaisDoisCaracteres": "AW",
            "siglaPaisTresCaracteres": "ABW",
            "nomePais": "Aruba",
            "codigoDdi": "297"
        },
        {
            "siglaPaisDoisCaracteres": "AZ",
            "siglaPaisTresCaracteres": "AZE",
            "nomePais": "Azerbaidjão",
            "codigoDdi": "994"
        },
        {
            "siglaPaisDoisCaracteres": "BA",
            "siglaPaisTresCaracteres": "BIH",
            "nomePais": "Bósnia-Herzegovina",
            "codigoDdi": "387"
        },
        {
            "siglaPaisDoisCaracteres": "BB",
            "siglaPaisTresCaracteres": "BRB",
            "nomePais": "Barbados",
            "codigoDdi": "1-246"
        },
        {
            "siglaPaisDoisCaracteres": "BD",
            "siglaPaisTresCaracteres": "BGD",
            "nomePais": "Bangladesh",
            "codigoDdi": "880"
        },
        {
            "siglaPaisDoisCaracteres": "BE",
            "siglaPaisTresCaracteres": "BEL",
            "nomePais": "Belgica",
            "codigoDdi": "32"
        },
        {
            "siglaPaisDoisCaracteres": "BF",
            "siglaPaisTresCaracteres": "BFA",
            "nomePais": "Burkina Fasso",
            "codigoDdi": "226"
        },
        {
            "siglaPaisDoisCaracteres": "BG",
            "siglaPaisTresCaracteres": "BGR",
            "nomePais": "Bulgária",
            "codigoDdi": "359"
        },
        {
            "siglaPaisDoisCaracteres": "BH",
            "siglaPaisTresCaracteres": "BHR",
            "nomePais": "Barein",
            "codigoDdi": "973"
        },
        {
            "siglaPaisDoisCaracteres": "BI",
            "siglaPaisTresCaracteres": "BDI",
            "nomePais": "Burundi",
            "codigoDdi": "257"
        },
        {
            "siglaPaisDoisCaracteres": "BJ",
            "siglaPaisTresCaracteres": "BEN",
            "nomePais": "Benin",
            "codigoDdi": "229"
        },
        {
            "siglaPaisDoisCaracteres": "BL",
            "siglaPaisTresCaracteres": "BLM",
            "nomePais": "Saint Bartholemy",
            "codigoDdi": "590"
        },
        {
            "siglaPaisDoisCaracteres": "BM",
            "siglaPaisTresCaracteres": "BMU",
            "nomePais": "Bermuda",
            "codigoDdi": "1-441"
        },
        {
            "siglaPaisDoisCaracteres": "BN",
            "siglaPaisTresCaracteres": "BRN",
            "nomePais": "Brunei",
            "codigoDdi": "673"
        },
        {
            "siglaPaisDoisCaracteres": "BO",
            "siglaPaisTresCaracteres": "BOL",
            "nomePais": "Bolívia",
            "codigoDdi": "591"
        },
        {
            "siglaPaisDoisCaracteres": "BQ",
            "siglaPaisTresCaracteres": "BES",
            "nomePais": "Bonaire, Saint Eustatius and Saba",
            "codigoDdi": "599"
        },
        {
            "siglaPaisDoisCaracteres": "BR",
            "siglaPaisTresCaracteres": "BRA",
            "nomePais": "Brasil",
            "codigoDdi": "55"
        },
        {
            "siglaPaisDoisCaracteres": "BS",
            "siglaPaisTresCaracteres": "BHS",
            "nomePais": "Bahamas",
            "codigoDdi": "1-242"
        },
        {
            "siglaPaisDoisCaracteres": "BT",
            "siglaPaisTresCaracteres": "BTN",
            "nomePais": "Butão",
            "codigoDdi": "975"
        },
        {
            "siglaPaisDoisCaracteres": "BW",
            "siglaPaisTresCaracteres": "BWA",
            "nomePais": "Botswana",
            "codigoDdi": "267"
        },
        {
            "siglaPaisDoisCaracteres": "BY",
            "siglaPaisTresCaracteres": "BLR",
            "nomePais": "Belarus",
            "codigoDdi": "375"
        },
        {
            "siglaPaisDoisCaracteres": "BZ",
            "siglaPaisTresCaracteres": "BLZ",
            "nomePais": "Belize",
            "codigoDdi": "501"
        },
        {
            "siglaPaisDoisCaracteres": "CA",
            "siglaPaisTresCaracteres": "CAN",
            "nomePais": "Canadá",
            "codigoDdi": "1"
        },
        {
            "siglaPaisDoisCaracteres": "CD",
            "siglaPaisTresCaracteres": "COD",
            "nomePais": "Democratic Republic of the Congo",
            "codigoDdi": "243"
        },
        {
            "siglaPaisDoisCaracteres": "CF",
            "siglaPaisTresCaracteres": "CAF",
            "nomePais": "República Centro-Africana",
            "codigoDdi": "236"
        },
        {
            "siglaPaisDoisCaracteres": "CG",
            "siglaPaisTresCaracteres": "COG",
            "nomePais": "Congo",
            "codigoDdi": "242"
        },
        {
            "siglaPaisDoisCaracteres": "CH",
            "siglaPaisTresCaracteres": "CHE",
            "nomePais": "Suiça",
            "codigoDdi": "41"
        },
        {
            "siglaPaisDoisCaracteres": "CI",
            "siglaPaisTresCaracteres": "CIV",
            "nomePais": "Costa do Marfim",
            "codigoDdi": "225"
        },
        {
            "siglaPaisDoisCaracteres": "CK",
            "siglaPaisTresCaracteres": "COK",
            "nomePais": "Ilhas Cook",
            "codigoDdi": "682"
        },
        {
            "siglaPaisDoisCaracteres": "CL",
            "siglaPaisTresCaracteres": "CHL",
            "nomePais": "Chile",
            "codigoDdi": "56"
        },
        {
            "siglaPaisDoisCaracteres": "CM",
            "siglaPaisTresCaracteres": "CMR",
            "nomePais": "Camarões",
            "codigoDdi": "237"
        },
        {
            "siglaPaisDoisCaracteres": "CN",
            "siglaPaisTresCaracteres": "CHN",
            "nomePais": "China",
            "codigoDdi": "86"
        },
        {
            "siglaPaisDoisCaracteres": "CO",
            "siglaPaisTresCaracteres": "COL",
            "nomePais": "Colômbia",
            "codigoDdi": "57"
        },
        {
            "siglaPaisDoisCaracteres": "CR",
            "siglaPaisTresCaracteres": "CRI",
            "nomePais": "Costa Rica",
            "codigoDdi": "506"
        },
        {
            "siglaPaisDoisCaracteres": "CU",
            "siglaPaisTresCaracteres": "CUB",
            "nomePais": "Cuba",
            "codigoDdi": "53"
        },
        {
            "siglaPaisDoisCaracteres": "CV",
            "siglaPaisTresCaracteres": "CPV",
            "nomePais": "Cabo Verde",
            "codigoDdi": "238"
        },
        {
            "siglaPaisDoisCaracteres": "CW",
            "siglaPaisTresCaracteres": "CUW",
            "nomePais": "Curaçao",
            "codigoDdi": "599"
        },
        {
            "siglaPaisDoisCaracteres": "CY",
            "siglaPaisTresCaracteres": "CYP",
            "nomePais": "Chipre",
            "codigoDdi": "357"
        },
        {
            "siglaPaisDoisCaracteres": "CZ",
            "siglaPaisTresCaracteres": "CZE",
            "nomePais": "República Tcheca",
            "codigoDdi": "420"
        },
        {
            "siglaPaisDoisCaracteres": "DE",
            "siglaPaisTresCaracteres": "DEU",
            "nomePais": "Alemanha",
            "codigoDdi": "49"
        },
        {
            "siglaPaisDoisCaracteres": "DJ",
            "siglaPaisTresCaracteres": "DJI",
            "nomePais": "Djibuti",
            "codigoDdi": "253"
        },
        {
            "siglaPaisDoisCaracteres": "DK",
            "siglaPaisTresCaracteres": "DNK",
            "nomePais": "Dinamarca",
            "codigoDdi": "45"
        },
        {
            "siglaPaisDoisCaracteres": "DM",
            "siglaPaisTresCaracteres": "DMA",
            "nomePais": "Dominica",
            "codigoDdi": "1-767"
        },
        {
            "siglaPaisDoisCaracteres": "DO",
            "siglaPaisTresCaracteres": "DOM",
            "nomePais": "República Dominicana",
            "codigoDdi": "1-809"
        },
        {
            "siglaPaisDoisCaracteres": "DZ",
            "siglaPaisTresCaracteres": "DZA",
            "nomePais": "Argélia",
            "codigoDdi": "213"
        },
        {
            "siglaPaisDoisCaracteres": "EC",
            "siglaPaisTresCaracteres": "ECU",
            "nomePais": "Equador",
            "codigoDdi": "593"
        },
        {
            "siglaPaisDoisCaracteres": "EE",
            "siglaPaisTresCaracteres": "EST",
            "nomePais": "Estônia",
            "codigoDdi": "372"
        },
        {
            "siglaPaisDoisCaracteres": "EG",
            "siglaPaisTresCaracteres": "EGY",
            "nomePais": "Egito",
            "codigoDdi": "20"
        },
        {
            "siglaPaisDoisCaracteres": "EH",
            "siglaPaisTresCaracteres": "ESH",
            "nomePais": "Sahara Ocidental",
            "codigoDdi": "212"
        },
        {
            "siglaPaisDoisCaracteres": "ER",
            "siglaPaisTresCaracteres": "ERI",
            "nomePais": "Eritréia",
            "codigoDdi": "291"
        },
        {
            "siglaPaisDoisCaracteres": "ES",
            "siglaPaisTresCaracteres": "ESP",
            "nomePais": "Espanha",
            "codigoDdi": "34"
        },
        {
            "siglaPaisDoisCaracteres": "ET",
            "siglaPaisTresCaracteres": "ETH",
            "nomePais": "Etiópia",
            "codigoDdi": "251"
        },
        {
            "siglaPaisDoisCaracteres": "FI",
            "siglaPaisTresCaracteres": "FIN",
            "nomePais": "Finlândia",
            "codigoDdi": "358"
        },
        {
            "siglaPaisDoisCaracteres": "FJ",
            "siglaPaisTresCaracteres": "FJI",
            "nomePais": "Fiji",
            "codigoDdi": "679"
        },
        {
            "siglaPaisDoisCaracteres": "FK",
            "siglaPaisTresCaracteres": "FLK",
            "nomePais": "Ilhas Malvinas",
            "codigoDdi": "500"
        },
        {
            "siglaPaisDoisCaracteres": "FM",
            "siglaPaisTresCaracteres": "FSM",
            "nomePais": "Micronésia",
            "codigoDdi": "691"
        },
        {
            "siglaPaisDoisCaracteres": "FO",
            "siglaPaisTresCaracteres": "FRO",
            "nomePais": "Ilhas Faroe",
            "codigoDdi": "298"
        },
        {
            "siglaPaisDoisCaracteres": "FR",
            "siglaPaisTresCaracteres": "FRA",
            "nomePais": "França",
            "codigoDdi": "33"
        },
        {
            "siglaPaisDoisCaracteres": "GA",
            "siglaPaisTresCaracteres": "GAB",
            "nomePais": "Gabão",
            "codigoDdi": "241"
        },
        {
            "siglaPaisDoisCaracteres": "GB",
            "siglaPaisTresCaracteres": "GBR",
            "nomePais": "Grã-Bretanha",
            "codigoDdi": "44"
        },
        {
            "siglaPaisDoisCaracteres": "GD",
            "siglaPaisTresCaracteres": "GRD",
            "nomePais": "Granada",
            "codigoDdi": "1-473"
        },
        {
            "siglaPaisDoisCaracteres": "GE",
            "siglaPaisTresCaracteres": "GEO",
            "nomePais": "Geórgia",
            "codigoDdi": "995"
        },
        {
            "siglaPaisDoisCaracteres": "GF",
            "siglaPaisTresCaracteres": "GUF",
            "nomePais": "Guiana Francesa",
            "codigoDdi": "594"
        },
        {
            "siglaPaisDoisCaracteres": "GG",
            "siglaPaisTresCaracteres": "GGY",
            "nomePais": "Guernsey",
            "codigoDdi": "44-1481"
        },
        {
            "siglaPaisDoisCaracteres": "GH",
            "siglaPaisTresCaracteres": "GHA",
            "nomePais": "Gana",
            "codigoDdi": "233"
        },
        {
            "siglaPaisDoisCaracteres": "GI",
            "siglaPaisTresCaracteres": "GIB",
            "nomePais": "Gibraltar",
            "codigoDdi": "350"
        },
        {
            "siglaPaisDoisCaracteres": "GL",
            "siglaPaisTresCaracteres": "GRL",
            "nomePais": "Groenlândia",
            "codigoDdi": "299"
        },
        {
            "siglaPaisDoisCaracteres": "GM",
            "siglaPaisTresCaracteres": "GMB",
            "nomePais": "Gâmbia",
            "codigoDdi": "220"
        },
        {
            "siglaPaisDoisCaracteres": "GN",
            "siglaPaisTresCaracteres": "GIN",
            "nomePais": "Guiné",
            "codigoDdi": "224"
        },
        {
            "siglaPaisDoisCaracteres": "GP",
            "siglaPaisTresCaracteres": "GLP",
            "nomePais": "Guadalupe",
            "codigoDdi": "590"
        },
        {
            "siglaPaisDoisCaracteres": "GQ",
            "siglaPaisTresCaracteres": "GNQ",
            "nomePais": "Guiné Equatorial",
            "codigoDdi": "240"
        },
        {
            "siglaPaisDoisCaracteres": "GR",
            "siglaPaisTresCaracteres": "GRC",
            "nomePais": "Grécia",
            "codigoDdi": "30"
        },
        {
            "siglaPaisDoisCaracteres": "GT",
            "siglaPaisTresCaracteres": "GTM",
            "nomePais": "Guatemala",
            "codigoDdi": "502"
        },
        {
            "siglaPaisDoisCaracteres": "GU",
            "siglaPaisTresCaracteres": "GUM",
            "nomePais": "Guam",
            "codigoDdi": "1-671"
        },
        {
            "siglaPaisDoisCaracteres": "GW",
            "siglaPaisTresCaracteres": "GNB",
            "nomePais": "Guiné-Bissau",
            "codigoDdi": "245"
        },
        {
            "siglaPaisDoisCaracteres": "GY",
            "siglaPaisTresCaracteres": "GUY",
            "nomePais": "Guiana",
            "codigoDdi": "592"
        },
        {
            "siglaPaisDoisCaracteres": "HK",
            "siglaPaisTresCaracteres": "HKG",
            "nomePais": "Hong Kong",
            "codigoDdi": "852"
        },
        {
            "siglaPaisDoisCaracteres": "HN",
            "siglaPaisTresCaracteres": "HND",
            "nomePais": "Honduras",
            "codigoDdi": "504"
        },
        {
            "siglaPaisDoisCaracteres": "HR",
            "siglaPaisTresCaracteres": "HRV",
            "nomePais": "Croácia",
            "codigoDdi": "385"
        },
        {
            "siglaPaisDoisCaracteres": "HT",
            "siglaPaisTresCaracteres": "HTI",
            "nomePais": "Haití",
            "codigoDdi": "509"
        },
        {
            "siglaPaisDoisCaracteres": "HU",
            "siglaPaisTresCaracteres": "HUN",
            "nomePais": "Hungria",
            "codigoDdi": "36"
        },
        {
            "siglaPaisDoisCaracteres": "ID",
            "siglaPaisTresCaracteres": "IDN",
            "nomePais": "Indonésia",
            "codigoDdi": "62"
        },
        {
            "siglaPaisDoisCaracteres": "IE",
            "siglaPaisTresCaracteres": "IRL",
            "nomePais": "Irlanda",
            "codigoDdi": "353"
        },
        {
            "siglaPaisDoisCaracteres": "IL",
            "siglaPaisTresCaracteres": "ISR",
            "nomePais": "Israel",
            "codigoDdi": "972"
        },
        {
            "siglaPaisDoisCaracteres": "IM",
            "siglaPaisTresCaracteres": "IMN",
            "nomePais": "Isle of Man",
            "codigoDdi": "44-1624"
        },
        {
            "siglaPaisDoisCaracteres": "IN",
            "siglaPaisTresCaracteres": "IND",
            "nomePais": "Índia",
            "codigoDdi": "91"
        },
        {
            "siglaPaisDoisCaracteres": "IQ",
            "siglaPaisTresCaracteres": "IRQ",
            "nomePais": "Iraque",
            "codigoDdi": "964"
        },
        {
            "siglaPaisDoisCaracteres": "IR",
            "siglaPaisTresCaracteres": "IRN",
            "nomePais": "Irã",
            "codigoDdi": "98"
        },
        {
            "siglaPaisDoisCaracteres": "IS",
            "siglaPaisTresCaracteres": "ISL",
            "nomePais": "Islândia",
            "codigoDdi": "354"
        },
        {
            "siglaPaisDoisCaracteres": "IT",
            "siglaPaisTresCaracteres": "ITA",
            "nomePais": "Itália",
            "codigoDdi": "39"
        },
        {
            "siglaPaisDoisCaracteres": "JE",
            "siglaPaisTresCaracteres": "JEY",
            "nomePais": "Jersey",
            "codigoDdi": "44-1534"
        },
        {
            "siglaPaisDoisCaracteres": "JM",
            "siglaPaisTresCaracteres": "JAM",
            "nomePais": "Jamaica",
            "codigoDdi": "1-876"
        },
        {
            "siglaPaisDoisCaracteres": "JO",
            "siglaPaisTresCaracteres": "JOR",
            "nomePais": "Jordânia",
            "codigoDdi": "962"
        },
        {
            "siglaPaisDoisCaracteres": "JP",
            "siglaPaisTresCaracteres": "JPN",
            "nomePais": "Japão",
            "codigoDdi": "81"
        },
        {
            "siglaPaisDoisCaracteres": "KE",
            "siglaPaisTresCaracteres": "KEN",
            "nomePais": "Quênia",
            "codigoDdi": "254"
        },
        {
            "siglaPaisDoisCaracteres": "KG",
            "siglaPaisTresCaracteres": "KGZ",
            "nomePais": "Quirguizia",
            "codigoDdi": "996"
        },
        {
            "siglaPaisDoisCaracteres": "KH",
            "siglaPaisTresCaracteres": "KHM",
            "nomePais": "Camboja",
            "codigoDdi": "855"
        },
        {
            "siglaPaisDoisCaracteres": "KI",
            "siglaPaisTresCaracteres": "KIR",
            "nomePais": "Kiribati",
            "codigoDdi": "686"
        },
        {
            "siglaPaisDoisCaracteres": "KM",
            "siglaPaisTresCaracteres": "COM",
            "nomePais": "Comores",
            "codigoDdi": "269"
        },
        {
            "siglaPaisDoisCaracteres": "KN",
            "siglaPaisTresCaracteres": "KNA",
            "nomePais": "São Cristóvão e Nevis",
            "codigoDdi": "1-869"
        },
        {
            "siglaPaisDoisCaracteres": "KP",
            "siglaPaisTresCaracteres": "PRK",
            "nomePais": "Coréia do Norte",
            "codigoDdi": "850"
        },
        {
            "siglaPaisDoisCaracteres": "KR",
            "siglaPaisTresCaracteres": "KOR",
            "nomePais": "Coréia do Sul",
            "codigoDdi": "82"
        },
        {
            "siglaPaisDoisCaracteres": "KW",
            "siglaPaisTresCaracteres": "KWT",
            "nomePais": "Kuweit",
            "codigoDdi": "965"
        },
        {
            "siglaPaisDoisCaracteres": "KY",
            "siglaPaisTresCaracteres": "CYM",
            "nomePais": "Ilhas Cayman",
            "codigoDdi": "1-345"
        },
        {
            "siglaPaisDoisCaracteres": "KZ",
            "siglaPaisTresCaracteres": "KAZ",
            "nomePais": "Cazaquistão",
            "codigoDdi": "7"
        },
        {
            "siglaPaisDoisCaracteres": "LA",
            "siglaPaisTresCaracteres": "LAO",
            "nomePais": "Laos",
            "codigoDdi": "856"
        },
        {
            "siglaPaisDoisCaracteres": "LB",
            "siglaPaisTresCaracteres": "LBN",
            "nomePais": "Líbano",
            "codigoDdi": "961"
        },
        {
            "siglaPaisDoisCaracteres": "LC",
            "siglaPaisTresCaracteres": "LCA",
            "nomePais": "Santa Lúcia",
            "codigoDdi": "1-758"
        },
        {
            "siglaPaisDoisCaracteres": "LI",
            "siglaPaisTresCaracteres": "LIE",
            "nomePais": "Liechtenstein",
            "codigoDdi": "423"
        },
        {
            "siglaPaisDoisCaracteres": "LK",
            "siglaPaisTresCaracteres": "LKA",
            "nomePais": "Sri lanka",
            "codigoDdi": "94"
        },
        {
            "siglaPaisDoisCaracteres": "LR",
            "siglaPaisTresCaracteres": "LBR",
            "nomePais": "Libéria",
            "codigoDdi": "231"
        },
        {
            "siglaPaisDoisCaracteres": "LS",
            "siglaPaisTresCaracteres": "LSO",
            "nomePais": "Lesoto",
            "codigoDdi": "266"
        },
        {
            "siglaPaisDoisCaracteres": "LT",
            "siglaPaisTresCaracteres": "LTU",
            "nomePais": "Lituânia",
            "codigoDdi": "370"
        },
        {
            "siglaPaisDoisCaracteres": "LU",
            "siglaPaisTresCaracteres": "LUX",
            "nomePais": "Luxemburgo",
            "codigoDdi": "352"
        },
        {
            "siglaPaisDoisCaracteres": "LV",
            "siglaPaisTresCaracteres": "LVA",
            "nomePais": "Letônia",
            "codigoDdi": "371"
        },
        {
            "siglaPaisDoisCaracteres": "LY",
            "siglaPaisTresCaracteres": "LBY",
            "nomePais": "Líbia",
            "codigoDdi": "218"
        },
        {
            "siglaPaisDoisCaracteres": "MA",
            "siglaPaisTresCaracteres": "MAR",
            "nomePais": "Marrocos",
            "codigoDdi": "212"
        },
        {
            "siglaPaisDoisCaracteres": "MC",
            "siglaPaisTresCaracteres": "MCO",
            "nomePais": "Mônaco",
            "codigoDdi": "377"
        },
        {
            "siglaPaisDoisCaracteres": "MD",
            "siglaPaisTresCaracteres": "MDA",
            "nomePais": "Moldavia",
            "codigoDdi": "373"
        },
        {
            "siglaPaisDoisCaracteres": "ME",
            "siglaPaisTresCaracteres": "MNE",
            "nomePais": "Montenegro",
            "codigoDdi": "382"
        },
        {
            "siglaPaisDoisCaracteres": "MF",
            "siglaPaisTresCaracteres": "MAF",
            "nomePais": "Saint Martin",
            "codigoDdi": "590"
        },
        {
            "siglaPaisDoisCaracteres": "MG",
            "siglaPaisTresCaracteres": "MDG",
            "nomePais": "Madagáscar",
            "codigoDdi": "261"
        },
        {
            "siglaPaisDoisCaracteres": "MH",
            "siglaPaisTresCaracteres": "MHL",
            "nomePais": "Ilhas Marshall",
            "codigoDdi": "692"
        },
        {
            "siglaPaisDoisCaracteres": "MK",
            "siglaPaisTresCaracteres": "MKD",
            "nomePais": "Macedônia",
            "codigoDdi": "389"
        },
        {
            "siglaPaisDoisCaracteres": "ML",
            "siglaPaisTresCaracteres": "MLI",
            "nomePais": "Mali",
            "codigoDdi": "223"
        },
        {
            "siglaPaisDoisCaracteres": "MM",
            "siglaPaisTresCaracteres": "MMR",
            "nomePais": "Mianmar",
            "codigoDdi": "95"
        },
        {
            "siglaPaisDoisCaracteres": "MN",
            "siglaPaisTresCaracteres": "MNG",
            "nomePais": "Mongólia",
            "codigoDdi": "976"
        },
        {
            "siglaPaisDoisCaracteres": "MO",
            "siglaPaisTresCaracteres": "MAC",
            "nomePais": "Macau",
            "codigoDdi": "853"
        },
        {
            "siglaPaisDoisCaracteres": "MP",
            "siglaPaisTresCaracteres": "MNP",
            "nomePais": "Ilhas Mariana",
            "codigoDdi": "1-670"
        },
        {
            "siglaPaisDoisCaracteres": "MQ",
            "siglaPaisTresCaracteres": "MTQ",
            "nomePais": "Martinica",
            "codigoDdi": "596"
        },
        {
            "siglaPaisDoisCaracteres": "MR",
            "siglaPaisTresCaracteres": "MRT",
            "nomePais": "Mauritânia",
            "codigoDdi": "222"
        },
        {
            "siglaPaisDoisCaracteres": "MS",
            "siglaPaisTresCaracteres": "MSR",
            "nomePais": "Montserrat",
            "codigoDdi": "1-664"
        },
        {
            "siglaPaisDoisCaracteres": "MT",
            "siglaPaisTresCaracteres": "MLT",
            "nomePais": "Malta",
            "codigoDdi": "356"
        },
        {
            "siglaPaisDoisCaracteres": "MU",
            "siglaPaisTresCaracteres": "MUS",
            "nomePais": "Maurício",
            "codigoDdi": "230"
        },
        {
            "siglaPaisDoisCaracteres": "MV",
            "siglaPaisTresCaracteres": "MDV",
            "nomePais": "Maldivas",
            "codigoDdi": "960"
        },
        {
            "siglaPaisDoisCaracteres": "MW",
            "siglaPaisTresCaracteres": "MWI",
            "nomePais": "Malaui",
            "codigoDdi": "265"
        },
        {
            "siglaPaisDoisCaracteres": "MX",
            "siglaPaisTresCaracteres": "MEX",
            "nomePais": "México",
            "codigoDdi": "52"
        },
        {
            "siglaPaisDoisCaracteres": "MY",
            "siglaPaisTresCaracteres": "MYS",
            "nomePais": "Malásia",
            "codigoDdi": "60"
        },
        {
            "siglaPaisDoisCaracteres": "MZ",
            "siglaPaisTresCaracteres": "MOZ",
            "nomePais": "Mocambique",
            "codigoDdi": "258"
        },
        {
            "siglaPaisDoisCaracteres": "NA",
            "siglaPaisTresCaracteres": "NAM",
            "nomePais": "Namíbia",
            "codigoDdi": "264"
        },
        {
            "siglaPaisDoisCaracteres": "NC",
            "siglaPaisTresCaracteres": "NCL",
            "nomePais": "Nova Caledônia",
            "codigoDdi": "687"
        },
        {
            "siglaPaisDoisCaracteres": "NE",
            "siglaPaisTresCaracteres": "NER",
            "nomePais": "Níger",
            "codigoDdi": "227"
        },
        {
            "siglaPaisDoisCaracteres": "NF",
            "siglaPaisTresCaracteres": "NFK",
            "nomePais": "Ilha Norfolk",
            "codigoDdi": "672"
        },
        {
            "siglaPaisDoisCaracteres": "NG",
            "siglaPaisTresCaracteres": "NGA",
            "nomePais": "Nigéria",
            "codigoDdi": "234"
        },
        {
            "siglaPaisDoisCaracteres": "NI",
            "siglaPaisTresCaracteres": "NIC",
            "nomePais": "Nicarágua",
            "codigoDdi": "505"
        },
        {
            "siglaPaisDoisCaracteres": "NL",
            "siglaPaisTresCaracteres": "NLD",
            "nomePais": "Holanda",
            "codigoDdi": "31"
        },
        {
            "siglaPaisDoisCaracteres": "NO",
            "siglaPaisTresCaracteres": "NOR",
            "nomePais": "Noruega",
            "codigoDdi": "47"
        },
        {
            "siglaPaisDoisCaracteres": "NP",
            "siglaPaisTresCaracteres": "NPL",
            "nomePais": "Nepal",
            "codigoDdi": "977"
        },
        {
            "siglaPaisDoisCaracteres": "NR",
            "siglaPaisTresCaracteres": "NRU",
            "nomePais": "Nauru",
            "codigoDdi": "674"
        },
        {
            "siglaPaisDoisCaracteres": "NU",
            "siglaPaisTresCaracteres": "NIU",
            "nomePais": "Niue",
            "codigoDdi": "683"
        },
        {
            "siglaPaisDoisCaracteres": "NZ",
            "siglaPaisTresCaracteres": "NZL",
            "nomePais": "Nova Zelândia",
            "codigoDdi": "64"
        },
        {
            "siglaPaisDoisCaracteres": "OM",
            "siglaPaisTresCaracteres": "OMN",
            "nomePais": "Omã",
            "codigoDdi": "968"
        },
        {
            "siglaPaisDoisCaracteres": "PA",
            "siglaPaisTresCaracteres": "PAN",
            "nomePais": "Panamá",
            "codigoDdi": "507"
        },
        {
            "siglaPaisDoisCaracteres": "PE",
            "siglaPaisTresCaracteres": "PER",
            "nomePais": "Peru",
            "codigoDdi": "51"
        },
        {
            "siglaPaisDoisCaracteres": "PF",
            "siglaPaisTresCaracteres": "PYF",
            "nomePais": "Polinésia Francesa",
            "codigoDdi": "689"
        },
        {
            "siglaPaisDoisCaracteres": "PG",
            "siglaPaisTresCaracteres": "PNG",
            "nomePais": "Papua Nova Guiné",
            "codigoDdi": "675"
        },
        {
            "siglaPaisDoisCaracteres": "PH",
            "siglaPaisTresCaracteres": "PHL",
            "nomePais": "Filipínas",
            "codigoDdi": "63"
        },
        {
            "siglaPaisDoisCaracteres": "PK",
            "siglaPaisTresCaracteres": "PAK",
            "nomePais": "Paquistão",
            "codigoDdi": "92"
        },
        {
            "siglaPaisDoisCaracteres": "PL",
            "siglaPaisTresCaracteres": "POL",
            "nomePais": "Polônia",
            "codigoDdi": "48"
        },
        {
            "siglaPaisDoisCaracteres": "PM",
            "siglaPaisTresCaracteres": "SPM",
            "nomePais": "São Pierre e Miquelon",
            "codigoDdi": "508"
        },
        {
            "siglaPaisDoisCaracteres": "PR",
            "siglaPaisTresCaracteres": "PRI",
            "nomePais": "Porto Rico",
            "codigoDdi": "1-787"
        },
        {
            "siglaPaisDoisCaracteres": "PS",
            "siglaPaisTresCaracteres": "PSE",
            "nomePais": "Palestinian Territory",
            "codigoDdi": "970"
        },
        {
            "siglaPaisDoisCaracteres": "PT",
            "siglaPaisTresCaracteres": "PRT",
            "nomePais": "Portugal",
            "codigoDdi": "351"
        },
        {
            "siglaPaisDoisCaracteres": "PW",
            "siglaPaisTresCaracteres": "PLW",
            "nomePais": "Palau",
            "codigoDdi": "680"
        },
        {
            "siglaPaisDoisCaracteres": "PY",
            "siglaPaisTresCaracteres": "PRY",
            "nomePais": "Paraguai",
            "codigoDdi": "595"
        },
        {
            "siglaPaisDoisCaracteres": "QA",
            "siglaPaisTresCaracteres": "QAT",
            "nomePais": "Catar",
            "codigoDdi": "974"
        },
        {
            "siglaPaisDoisCaracteres": "RE",
            "siglaPaisTresCaracteres": "REU",
            "nomePais": "Ilhas Reunião",
            "codigoDdi": "262"
        },
        {
            "siglaPaisDoisCaracteres": "RO",
            "siglaPaisTresCaracteres": "ROM",
            "nomePais": "Romênia",
            "codigoDdi": "40"
        },
        {
            "siglaPaisDoisCaracteres": "RS",
            "siglaPaisTresCaracteres": "SRB",
            "nomePais": "Serbia",
            "codigoDdi": "381"
        },
        {
            "siglaPaisDoisCaracteres": "RU",
            "siglaPaisTresCaracteres": "RUS",
            "nomePais": "Federação Russa",
            "codigoDdi": "7"
        },
        {
            "siglaPaisDoisCaracteres": "RW",
            "siglaPaisTresCaracteres": "RWA",
            "nomePais": "Ruanda",
            "codigoDdi": "250"
        },
        {
            "siglaPaisDoisCaracteres": "SA",
            "siglaPaisTresCaracteres": "SAU",
            "nomePais": "Arábia Saudita",
            "codigoDdi": "966"
        },
        {
            "siglaPaisDoisCaracteres": "SB",
            "siglaPaisTresCaracteres": "SLB",
            "nomePais": "Ilhas Salomão",
            "codigoDdi": "677"
        },
        {
            "siglaPaisDoisCaracteres": "SC",
            "siglaPaisTresCaracteres": "SYC",
            "nomePais": "Seicheles",
            "codigoDdi": "248"
        },
        {
            "siglaPaisDoisCaracteres": "SD",
            "siglaPaisTresCaracteres": "SDN",
            "nomePais": "Sudão",
            "codigoDdi": "249"
        },
        {
            "siglaPaisDoisCaracteres": "SE",
            "siglaPaisTresCaracteres": "SWE",
            "nomePais": "Suécia",
            "codigoDdi": "46"
        },
        {
            "siglaPaisDoisCaracteres": "SG",
            "siglaPaisTresCaracteres": "SGP",
            "nomePais": "Cingapura",
            "codigoDdi": "65"
        },
        {
            "siglaPaisDoisCaracteres": "SI",
            "siglaPaisTresCaracteres": "SVN",
            "nomePais": "Eslovênia",
            "codigoDdi": "386"
        },
        {
            "siglaPaisDoisCaracteres": "SJ",
            "siglaPaisTresCaracteres": "SJM",
            "nomePais": "Ilhas Svalbard e Jan Mayen",
            "codigoDdi": "47"
        },
        {
            "siglaPaisDoisCaracteres": "SK",
            "siglaPaisTresCaracteres": "SVK",
            "nomePais": "Eslováquia",
            "codigoDdi": "421"
        },
        {
            "siglaPaisDoisCaracteres": "SL",
            "siglaPaisTresCaracteres": "SLE",
            "nomePais": "Serra Leoa",
            "codigoDdi": "232"
        },
        {
            "siglaPaisDoisCaracteres": "SM",
            "siglaPaisTresCaracteres": "SMR",
            "nomePais": "San Marino",
            "codigoDdi": "378"
        },
        {
            "siglaPaisDoisCaracteres": "SN",
            "siglaPaisTresCaracteres": "SEN",
            "nomePais": "Senegal",
            "codigoDdi": "221"
        },
        {
            "siglaPaisDoisCaracteres": "SO",
            "siglaPaisTresCaracteres": "SOM",
            "nomePais": "Somália",
            "codigoDdi": "252"
        },
        {
            "siglaPaisDoisCaracteres": "SR",
            "siglaPaisTresCaracteres": "SUR",
            "nomePais": "Suriname",
            "codigoDdi": "597"
        },
        {
            "siglaPaisDoisCaracteres": "SS",
            "siglaPaisTresCaracteres": "SSD",
            "nomePais": "South Sudan",
            "codigoDdi": "211"
        },
        {
            "siglaPaisDoisCaracteres": "ST",
            "siglaPaisTresCaracteres": "STP",
            "nomePais": "São Tomé e Príncipe",
            "codigoDdi": "239"
        },
        {
            "siglaPaisDoisCaracteres": "SV",
            "siglaPaisTresCaracteres": "SLV",
            "nomePais": "El Salvador",
            "codigoDdi": "503"
        },
        {
            "siglaPaisDoisCaracteres": "SX",
            "siglaPaisTresCaracteres": "SXM",
            "nomePais": "Sint Maarten",
            "codigoDdi": "599"
        },
        {
            "siglaPaisDoisCaracteres": "SY",
            "siglaPaisTresCaracteres": "SYR",
            "nomePais": "Síria",
            "codigoDdi": "963"
        },
        {
            "siglaPaisDoisCaracteres": "SZ",
            "siglaPaisTresCaracteres": "SWZ",
            "nomePais": "Suazilândia",
            "codigoDdi": "268"
        },
        {
            "siglaPaisDoisCaracteres": "TC",
            "siglaPaisTresCaracteres": "TCA",
            "nomePais": "Ilhas Turks e Caicos",
            "codigoDdi": "1-649"
        },
        {
            "siglaPaisDoisCaracteres": "TD",
            "siglaPaisTresCaracteres": "TCD",
            "nomePais": "Chade",
            "codigoDdi": "235"
        },
        {
            "siglaPaisDoisCaracteres": "TG",
            "siglaPaisTresCaracteres": "TGO",
            "nomePais": "Togo",
            "codigoDdi": "228"
        },
        {
            "siglaPaisDoisCaracteres": "TH",
            "siglaPaisTresCaracteres": "THA",
            "nomePais": "Tailândia",
            "codigoDdi": "66"
        },
        {
            "siglaPaisDoisCaracteres": "TJ",
            "siglaPaisTresCaracteres": "TJK",
            "nomePais": "Tadjiquistão",
            "codigoDdi": "992"
        },
        {
            "siglaPaisDoisCaracteres": "TK",
            "siglaPaisTresCaracteres": "TKL",
            "nomePais": "Ilhas Tokelau",
            "codigoDdi": "690"
        },
        {
            "siglaPaisDoisCaracteres": "TL",
            "siglaPaisTresCaracteres": "TLS",
            "nomePais": "Timor Leste",
            "codigoDdi": "670"
        },
        {
            "siglaPaisDoisCaracteres": "TM",
            "siglaPaisTresCaracteres": "TKM",
            "nomePais": "Turcomênia",
            "codigoDdi": "993"
        },
        {
            "siglaPaisDoisCaracteres": "TN",
            "siglaPaisTresCaracteres": "TUN",
            "nomePais": "Tunísia",
            "codigoDdi": "216"
        },
        {
            "siglaPaisDoisCaracteres": "TO",
            "siglaPaisTresCaracteres": "TON",
            "nomePais": "Tonga",
            "codigoDdi": "676"
        },
        {
            "siglaPaisDoisCaracteres": "TR",
            "siglaPaisTresCaracteres": "TUR",
            "nomePais": "Turquia",
            "codigoDdi": "90"
        },
        {
            "siglaPaisDoisCaracteres": "TT",
            "siglaPaisTresCaracteres": "TTO",
            "nomePais": "Trinidad e Tobago",
            "codigoDdi": "1-868"
        },
        {
            "siglaPaisDoisCaracteres": "TV",
            "siglaPaisTresCaracteres": "TUV",
            "nomePais": "Tuvalu",
            "codigoDdi": "688"
        },
        {
            "siglaPaisDoisCaracteres": "TW",
            "siglaPaisTresCaracteres": "TWN",
            "nomePais": "Taiwan",
            "codigoDdi": "886"
        },
        {
            "siglaPaisDoisCaracteres": "TZ",
            "siglaPaisTresCaracteres": "TZA",
            "nomePais": "Tanzânia",
            "codigoDdi": "255"
        },
        {
            "siglaPaisDoisCaracteres": "UA",
            "siglaPaisTresCaracteres": "UKR",
            "nomePais": "Ucrânia",
            "codigoDdi": "380"
        },
        {
            "siglaPaisDoisCaracteres": "UG",
            "siglaPaisTresCaracteres": "UGA",
            "nomePais": "Uganda",
            "codigoDdi": "256"
        },
        {
            "siglaPaisDoisCaracteres": "US",
            "siglaPaisTresCaracteres": "USA",
            "nomePais": "Estados Unidos da América",
            "codigoDdi": "1"
        },
        {
            "siglaPaisDoisCaracteres": "UY",
            "siglaPaisTresCaracteres": "URY",
            "nomePais": "Uruguai",
            "codigoDdi": "598"
        },
        {
            "siglaPaisDoisCaracteres": "UZ",
            "siglaPaisTresCaracteres": "UZB",
            "nomePais": "Uzbequistão",
            "codigoDdi": "998"
        },
        {
            "siglaPaisDoisCaracteres": "VA",
            "siglaPaisTresCaracteres": "VAT",
            "nomePais": "Vaticano",
            "codigoDdi": "379"
        },
        {
            "siglaPaisDoisCaracteres": "VC",
            "siglaPaisTresCaracteres": "VCT",
            "nomePais": "São Vicente e Granadinas",
            "codigoDdi": "1-784"
        },
        {
            "siglaPaisDoisCaracteres": "VE",
            "siglaPaisTresCaracteres": "VEN",
            "nomePais": "Venezuela",
            "codigoDdi": "58"
        },
        {
            "siglaPaisDoisCaracteres": "VG",
            "siglaPaisTresCaracteres": "VGB",
            "nomePais": "Ilhas Virgens Britânicas",
            "codigoDdi": "1-284"
        },
        {
            "siglaPaisDoisCaracteres": "VI",
            "siglaPaisTresCaracteres": "VIR",
            "nomePais": "Ilhas Virgens",
            "codigoDdi": "1-340"
        },
        {
            "siglaPaisDoisCaracteres": "VN",
            "siglaPaisTresCaracteres": "VNM",
            "nomePais": "Vietnã",
            "codigoDdi": "84"
        },
        {
            "siglaPaisDoisCaracteres": "VU",
            "siglaPaisTresCaracteres": "VUT",
            "nomePais": "Vanuatu",
            "codigoDdi": "678"
        },
        {
            "siglaPaisDoisCaracteres": "WF",
            "siglaPaisTresCaracteres": "WLF",
            "nomePais": "Ilhas Wallis e Futuna",
            "codigoDdi": "681"
        },
        {
            "siglaPaisDoisCaracteres": "WS",
            "siglaPaisTresCaracteres": "WSM",
            "nomePais": "Samôa Ocidental",
            "codigoDdi": "685"
        },
        {
            "siglaPaisDoisCaracteres": "YE",
            "siglaPaisTresCaracteres": "YEM",
            "nomePais": "Iêmen",
            "codigoDdi": "967"
        },
        {
            "siglaPaisDoisCaracteres": "YT",
            "siglaPaisTresCaracteres": "MYT",
            "nomePais": "Mayotte",
            "codigoDdi": "262"
        },
        {
            "siglaPaisDoisCaracteres": "ZA",
            "siglaPaisTresCaracteres": "ZAF",
            "nomePais": "África do Sul",
            "codigoDdi": "27"
        },
        {
            "siglaPaisDoisCaracteres": "ZM",
            "siglaPaisTresCaracteres": "ZMB",
            "nomePais": "Zâmbia",
            "codigoDdi": "260"
        },
        {
            "siglaPaisDoisCaracteres": "ZW",
            "siglaPaisTresCaracteres": "ZWE",
            "nomePais": "Zimbabue",
            "codigoDdi": "263"
        }
    ]
}